var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 13.875H3.25V12.125H13.75V13.875ZM13.75 10.375H3.25V8.625H13.75V10.375ZM13.75 6.875H3.25V5.125H13.75V6.875ZM0.625 18.25L1.9375 16.9375L3.25 18.25L4.5625 16.9375L5.875 18.25L7.1875 16.9375L8.5 18.25L9.8125 16.9375L11.125 18.25L12.4375 16.9375L13.75 18.25L15.0625 16.9375L16.375 18.25V0.75L15.0625 2.0625L13.75 0.75L12.4375 2.0625L11.125 0.75L9.8125 2.0625L8.5 0.75L7.1875 2.0625L5.875 0.75L4.5625 2.0625L3.25 0.75L1.9375 2.0625L0.625 0.75V18.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoice);
export default __webpack_public_path__ + "static/media/invoice.3de7a5f85811af3e657870e4a75f0275.svg";
export { ForwardRef as ReactComponent };